'use client'
import useAirlineFilterManager from '@/src/hooks/srp/airlineFilterManager'
import { DeviceType } from '@/src/types/deviceType'
import { AirlinesFilter } from './AirlinesFilter'

interface AirlinesFilterWrapperSideBarProps {
    deviceType: DeviceType
}

const AirlinesFilterWrapperSideBar = ({ deviceType }: AirlinesFilterWrapperSideBarProps) => {
    const { airlines, handleSelectToggle, handleReset, shouldShowReset, title } = useAirlineFilterManager()

    return (
        <AirlinesFilter
            airlines={airlines}
            onAirlineSelect={id => handleSelectToggle(id, 'FilterWrapperSideBar')}
            onReset={handleReset}
            shouldShowReset={shouldShowReset}
            title={title}
            deviceType={deviceType}
        />
    )
}

export { AirlinesFilterWrapperSideBar }
export default AirlinesFilterWrapperSideBar
